/**
 * Auth Verify
 *
 * @param {string} alias the users alias
 * @param {string} ui the app url or name i.e. app.abaxx.id
 * @param {number} authMode the selected auth mode for authentication
 * 
 */

// export const auth = async (alias: string, appId: any, authMode: any, token: any) => {
//   try {
//     const response = await fetch(`${process.env.REACT_APP_API_URL}/chain/auth/${alias}/${appId}/${authMode}/${token}`, {
//       method: 'GET',
//       headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json',
//       },
//     })
//     return await response.json();
//   } catch (error) {
//     console.log(error);
//   }
// };

/**
 * Authorized Login
 * 
 * From scanned QR data, 
 * sends request to api to login on a specific device.
 *
 * @param {string} alias the user's alias
 * @param {number} appId data from the scanned device
 * @param {string} deviceId data from the scanned device
 * @param {string} devicePushToken data from the scanned device
 */
 export const authLogin = async (
   alias: string,
   appId: any,
   deviceId: string,
   devicePushToken: string,
   authToken: string,
   authRequestId: string,
) => {
  const payload = {
    alias,
    appId,
    deviceId,
    devicePushToken,
    authRequestId
  };

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/chain/auth-login`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authToken
      },
      body: JSON.stringify(payload),
    })
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};


/**
 * Verify SMS Code
 *
 * @param {string} identity the identity address
 * @param {object} metadata the object that contains the following format
 * 
 * @example body example
 * {
 *    "identity": "0x0101010101010101010101",
 *    "metadata": {
 *      "number": "2125551212",
 *      "countryCode": "1",
 *      "code": "1234"
 *    }
 * }
 * 
 */
export const verifySMS = async (identity: any, metadata: any) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/chain/phone/verify`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ identity, metadata })
    })
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};


// unused code below
// export const sendPush = async (payload: any) => {
//   try {
//     const response = await fetch(`${process.env.REACT_APP_API_URL}/sms/send`, {
//       method: 'POST',
//       headers: {
//         'Accept': 'application/json',
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(payload)
//     })
//     return await response.json();
//   } catch (error) {
//     console.log(error);
//   }
// }